import request from '@/axios/axios'

// 设备详情（标识、状态、信息）
export function deviceContent(query) {
  return request({
    url: '/log/v1/device/content',
    method: 'get',
    params: query
  })
}

// 设备属性获取
export function getProperties(query) {
  return request({
    url: '/log/v1/device/product/properties',
    method: 'get',
    params: query
  })
}

// 日志详情列表
export function logDetailsList(params) {
  return request({
    url: '/log/v1/device/protocol/log',
    method: 'post',
    data: params
  })
}

// 设备本地日志列表
export function localLogs(params) {
  return request({
    url: '/log/v1/device/log',
    method: 'post',
    data: params
  })
}

// 启动收集
export function startCollect(params) {
  return request({
    url: '/device/v1/logs/upload/start-collecting-log',
    method: 'post',
    data: params
  })
}

// 停止收集
export function stopCollect(params) {
  return request({
    url: 'device/v1/logs/upload/stop-collecting-log',
    method: 'post',
    data: params
  })
}

